<template>
  <div id="home">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
      <router-link to="/" class="navbar-brand">
        <img src="src/assets/logo.png" class="d-inline-block align-middle" alt="" height="30">
        <span class="h1 navbar-brand mb-0">Lernin Games</span>
      </router-link>
    </nav>
    <div class="container">
      <h1>Lernin games</h1>
      <list-games/>
    </div>
  </div>
</template>

<script>
import ListGames from './ListGames.vue';

export default {
  name: 'home',
  components: {
    'list-games': ListGames
  },
  data () {
    return {
    }
  },
  created: function() {
    console.log('home created');
    // ...
  }
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// Home.vue?7b645ece